import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventService} from "../../../../service/api/event.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../model/response/ApiResponse";
import {ErrorMessageEnum} from "../../../enums/error-message.enum";

@Component({
    selector: 'app-event-remove-modal',
    templateUrl: './event-remove-modal.component.html',
    standalone: false
})
export class EventRemoveModalComponent {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean

  @Input('isEventOwner') isEventOwner: boolean

  @Output('onCloseSuccess') onCloseSuccess = new EventEmitter<any>()
  @Output('onCancelModal') onCancelModal = new EventEmitter<any>()

  form: FormGroup
  outcomeFormError: string = null
  isLoading = false;

  constructor(
    private eventService: EventService,
    private messageToast: MessageToastService,
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      "reason": new FormControl(null, Validators.required),
    });
  }

  onSubmit() {
    this.outcomeFormError = null

    //validate the field only if user is not the owner of the event
    if (!this.isEventOwner && this.form.invalid) {
      if (this.form.get("reason")?.hasError("required")) {
        this.outcomeFormError = ErrorMessageEnum.requiredField
      }
    } else {
      this.isLoading = true
      this.apiDeleteEvent()
    }
  }

  apiDeleteEvent() {
    const reason: string = this.form.value["reason"]
    this.eventService.removeEvent(this.event.id, reason).pipe(
      finalize(() => this.isLoading = false),
      tap({
        next: value => {
          this.messageToast.success(value.message)
          this.onCloseSuccess.emit(value?.data)
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<any>) => {
          this.messageToast.error(err?.message)

          if (err?.formErrors) {
            this.outcomeFormError = err.formErrors.get("reason")
          }
        }
      })).subscribe()
  }

}
